import React from 'react';
import styles from './CountDown.module.css';
import { dateDiff } from './CountDownLogic';

const CountDown = () => {
    const days = dateDiff(new Date(), new Date(2026, 10, 29));
    return days ? <div>
        <a href="https://goriseki1129.web.app" target="_blank" rel="noopener noreferrer">
            <h2>
                <div className={styles.normal}>ご臨席総会(2026.11.29)まであと</div>
                <span className={styles.big}>{days}日</span>
                <br/>
                ご臨席総会のページはこちら
            </h2>
        </a>
    </div> : <></>
}

export default CountDown;